/**
 * Estamos rodando em um celular?
 *
 * @return {boolean}
 */
export function mobile(width) {
    width = width || window.innerWidth
    return width < 768
}

/**
 * Estamos rodando em um emulador android no ambiente de desenvolvimento?
 *
 * @return {boolean}
 */
export function emuladorAndroid() {
    return document.location.hostname.indexOf('10.0.2.2') !== -1
}
